import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

export default function Layout({ activeModule, onModuleChange, children }) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="layout">
      <Sidebar
        activeModule={activeModule}
        onModuleChange={onModuleChange}
        collapsed={collapsed}
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
      />
      <div className="layout-main">
        <Header activeModule={activeModule} />
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
}
